import type { PortableTextListItemComponent } from '@portabletext/react';

const ListItem: PortableTextListItemComponent = ({ children }) => (
  <li className="text-xl">{children}</li>
);

export default ListItem;

export const ListItemHtml: PortableTextListItemComponent = ({ children }) => (
  <li>{children}</li>
);
